import { Stack, Tab, Tabs } from "@mui/material";

import { useEffect, useState } from "react";

import RenderTabs from "./RenderTabs/RenderTabs";
import { useSearchParams } from "react-router-dom";

function a11yProps(key) {
	return {
		id: key,
	};
}
const tabStyle = { textTransform: "capitalize", fontSize: "16px", width: "170px" };

export const FOBPoTabs = {
	create_po: { name: "Create PO", key: "create_po", no: 0 },
	all_po: { name: "All PO", key: "all_po", no: 1 },
	report: { name: "Report", key: "report", no: 2 },
};

const FOBPurchaseOrder = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const [tab, setTab] = useState(FOBPoTabs.create_po.key);

	const handleTabChange = (event, value) => {
		setTab(value);
		setSearchParams({ tab: value });
	};
	useEffect(() => {
		let urlTab = searchParams.get("tab");
		if (urlTab) setTab(urlTab);
	}, []);

	return (
		<Stack width="100%" spacing={1} pt={1}>
			<Tabs
				value={tab}
				onChange={handleTabChange}
				aria-label="basic tabs example"
				sx={{ borderBottom: 1, borderColor: "divider" }}>
				{Object.keys(FOBPoTabs).map((key) => {
					const obj = FOBPoTabs[key];
					return <Tab sx={tabStyle} label={obj?.name} {...a11yProps(obj?.key)} value={obj?.key} />;
				})}
			</Tabs>
			<RenderTabs selectedTab={tab} setSelectedTab={setTab} />
		</Stack>
	);
};

export default FOBPurchaseOrder;
